import { Ajax } from "../utils/base";
import IP from "../config/config"
import Qs from "qs"
// 篮球球员基础数据
export function getLQPlayerInfo (param) {
    const url = IP.dcApis() + '/basketball/getPlayerInfo';
    return Ajax(url, param, "GET");
}
// 篮球球队基础数据
export function getLQTeamInfo (param) {
    const url = IP.dcApis() + '/basketball/getTeamInfo';
    return Ajax(url, param, "GET");
}
//
export function getLQTeamInfoBase (param) {
    const url = IP.mApis() + '/basketball/team/info';
    return Ajax(url, param, "GET");
}
// 篮球球队赛程
export function getLQTeamSchedule (param) {
    const url = IP.mApis() + '/basketball/team/schedule';
    return Ajax(url, param, "GET");
}
// 篮球球队阵容
export function getLQTeamLineup (param) {
    const url = IP.mApis() + '/basketball/team/lineup';
    return Ajax(url, param, "GET");
}
// 篮球球队阵容
export function getLQTeamData (param) {
    const url = IP.mApis() + '/basketball/team/data';
    return Ajax(url, param, "GET");
}
// 篮球球队动态
export function getAggDisByTid (param) {
    const url = IP.bbsApis() + '/pc/Discussions/getAggDisByTid';
    return Ajax(url, param, "GET");
}
// ========球员========
// 球员资料
export function getPlayerBase (param) {
    const url = IP.mApis() + '/basketball/player/base';
    return Ajax(url, param, "GET");
}
// 球员信息
export function getPlayerBaseInfo (param) {
    const url = IP.mApis() + '/basketball/player/info';
    return Ajax(url, param, "GET");
}
// 球员生涯
export function getPlayerCareer (param) {
    const url = IP.mApis() + '/basketball/player/career';
    return Ajax(url, param, "GET");
}
// 动态关注
export function getUserFollow (param) {
    const url = IP.passportApis() + '/user/follow';
    return Ajax(url, Qs.stringify(param), "POST");
}
// 动态取消关注
export function getUserUnfollow (param) {
    const url = IP.passportApis() + '/user/unfollow';
    return Ajax(url, Qs.stringify(param), "POST");
}
// 动态点赞
export function getUserLike (param) {
    const url = IP.bbsApis() + '/pc/user/like';
    return Ajax(url, Qs.stringify(param), "POST");
}
// 篮球关注球员
export function getFollowPlayer (param) {
    const url = IP.dcApis() + '/basketball/followPlayer';
    return Ajax(url, Qs.stringify(param), "POST");
}
// 篮球关注球队
export function getFollowTeam (param) {
    const url = IP.dcApis() + '/basketball/followTeam';
    return Ajax(url, Qs.stringify(param), "POST");
}
